import { Component, OnInit } from '@angular/core';

import { TemplateService } from 'app/_services/template.service';
import { TokenStorageService } from '../../_services/token-storage.service';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss']
})
export class TemplatesComponent implements OnInit {
  templateList: any[] = [];

  constructor(
    private template: TemplateService,
    private tokenStorage: TokenStorageService
  ) { }

  ngOnInit(): void {
    const contactUUID = this.tokenStorage.getToken() || "";

    this.template.getTemplatesList$(contactUUID).subscribe({
      next: (templates: []) => {
        this.templateList = templates;
      },
      error: (err: any) => {
        console.log("Something went wronf fetching templates: ", err)
      }
    });
  }

}